import styled from '@emotion/styled/macro';
import { BaseButton, BaseNavLink, forPhoneOnly, Variables } from '@enter/core';
import { Icon } from '@mdi/react';

export const NavLink = styled(BaseNavLink)`
    display: inline-block;
    ${forPhoneOnly(`
        display: none;
    `)};
`;

export const StyledButton = styled(BaseButton)`
    background-color: ${Variables.Colors.white};
    border: none;
    box-shadow: ${Variables.Shadows.small};
`;

export const StyledIcon = styled(Icon)`
    height: 24px;
    width: 24px;
    fill: ${Variables.Colors.n30};

    ${StyledButton}:hover & {
        path {
            fill: ${Variables.Colors.n50};
        }
    }
    ${StyledButton}:active & {
        path {
            fill: ${Variables.Colors.n30};
        }
    }
`;
